import { getApiUrlString, setUrlMap } from '../modules/get_apiUrlString'

import roundCommonProcess from './process/roundCommonProcess'

console.log('api_thread_round.js')
const urlMap = {};

onmessage = async function(ev) {
  Object.assign(urlMap, ev.data);
  setUrlMap(urlMap);
  console.log('urlMap', urlMap);

  const postData = await roundCommonProcess(ev.data);
  console.log(postData);
  if (postData.type == 'error') {
    postData.cb();
    return;
  }

  // 参加選手（斡旋された選手）用のデータ取得
  const mediationQueryString = `?promoter_year=${postData.promote.year}&season=${postData.promote.season}&round_code=${postData.page.roundCode}`;
  const mediationResultPromise = await fetch(getApiUrlString('mediation', mediationQueryString))
    .then(res => res.json())
    .then(res => {
      return {
        updatedAt: res.data.updated_at.replace(/([0-9]+)-([0-9]+)-([0-9]+)\s([0-9]+):([0-9]+)(.*)/g, (_1, _2, p2, p3, p4, p5) => {
          return `${p2}月${p3}日${p4}時${p5}分 更新`
        }),
        playerList: res.data.player_list,
        additionalList: res.data.additional_list,
        absenceList: res.data.absence_list,
        cancelledList: res.data.cancelled_list,
        isMediationDiscontinuation: res.data.hold_status == 2
      }
    });

  postData.updatedAt = mediationResultPromise.updatedAt;

  // 上から順番に
  //  斡旋選手リスト
  //  追加斡旋選手リスト
  //  途中欠場選手リスト
  //  欠場選手リスト
  postData.mediation = mediationResultPromise.playerList.map(playerInfo => createMeditationListItemStr(playerInfo)).join('');
  postData.additional = mediationResultPromise.additionalList.map(playerInfo => createMeditationListItemStr(playerInfo)).join('');
  postData.absence = mediationResultPromise.absenceList.map(playerInfo => createMeditationListItemStr(playerInfo)).join('');
  postData.cancelled = mediationResultPromise.cancelledList.map(playerInfo => createMeditationListItemStr(playerInfo, false)).join('');

  // ラウンド開催ステータス
  postData.page.isMediationDiscontinuation = mediationResultPromise.isMediationDiscontinuation;

  // メインスレッドへのデータ返却
  postMessage(postData);
}

const createMeditationListItemStr = (playerInfo, isLink = true) => {
  const name = `${playerInfo.last_name_jp} ${playerInfo.first_name_jp}`;
  // country_code からは旗の画像要素のテキスト生成
  const flagNode = playerInfo.country_code
    ? `<img class="le-meditation-list__td-img _flag" src="${urlMap.imgOrigin}/national_flag/${playerInfo.country_code}/data.svg" onerror="this.parentElement.textContent='ー';">`
    : 'ー';

  // リンクの有無によって要素の構成変更
  const thumbWrapNodeStr = (() => {
    const thumbImgStr =`<img class="le-meditation-list__td-img" src="${urlMap.imgOrigin}/player/${playerInfo.id}/410x536.png" alt="${name}" onerror="this.src='/assets/images/league/under/timetrial/img_thumb_noimage.png'">`;
    return isLink
      ? `<a href="/player/detail/?player_id=${playerInfo.id}" target="_blank">${thumbImgStr}</a>`
      : thumbImgStr;
  })();

  // リンクの有無によって要素のnodeName(localName)変更
  const nameWrapNodeStr = (() => {
    const nameParaStr = `<p class="le-meditation-list__td-txt">${name}</p>`;
    return isLink
      ? `<a href="/player/detail/?player_id=${playerInfo.id}" target="_blank" class="le-meditation-list__td _name">${nameParaStr}</a>`
      : `<div class="le-meditation-list__td _name">${nameParaStr}</div>`;
  })();
  return `<li class="le-meditation-list__tr">
    <div class="le-meditation-list__td _thumb">${thumbWrapNodeStr}</div>
    ${nameWrapNodeStr}
    <div class="le-meditation-list__td _countory"><span class="le-meditation-list__td-flag">${flagNode}</span></div>
  </li>`;
}
